// forces compile errors when a case in reducer is missing
const assertNever = (x: never): never => {
    throw new Error(`Unhandled action: ${JSON.stringify(x)}`);
};

const normalizeReadingValue = (raw: string | number | null | undefined, preDecimals: number, postDecimals: number): string => {
    if (raw == null) return '';
    // to string, trim, normalize decimal separator
    let s = String(raw).trim().replace(',', '.');

    // keep digits and dots only
    s = s.replace(/[^0-9.]/g, '');

    // if there are no digits at all, it's not a number -> empty
    if (!/[0-9]/.test(s)) {
        return '';
    }

    // if multiple dots, keep only the first
    const firstDot = s.indexOf('.');
    if (firstDot !== -1) {
        s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, ''); // remove remaining dots
    }

    let [intPart = '', fracPart = ''] = s.split('.');

    // default leading dot like ".1" -> "0.1"
    if (intPart === '' && fracPart !== '') intPart = '0';

    // strip leading zeros but keep one if all zeros, otherwise remove them
    if (/^0+$/.test(intPart)) {
        intPart = '0';
    } else {
        intPart = intPart.replace(/^0+/, '');
    }

    if (postDecimals === 0) {
        // ignore any fractional input
        return intPart;
    }

    fracPart = (fracPart || '').slice(0, postDecimals);

    // return with fracPart if present (no dangling dot)
    return fracPart.length ? `${intPart}.${fracPart}` : intPart;
};

export default {
    assertNever,
    normalizeReadingValue,
} as const;
